import {
  IArmDisarmPartialAlarmCentralParams,
  IBypassZoneParams,
  IPgmActivationParams,
  ISingleBypassZoneParams,
} from '../types';
import { api } from '../../DefaultService';
import { ALARM_CENTRAL_JFL_ENDPOINT } from './Jfl';

export const armPhysicalByPartitionAlarmCentral = async ({
  id,
  partition,
  endpoint,
}: IArmDisarmPartialAlarmCentralParams) => {
  return await api
    .post(`${endpoint}/${id}/arm/${partition}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const disarmPhysicalByPartitionAlarmCentral = async ({
  id,
  partition,
  endpoint,
}: IArmDisarmPartialAlarmCentralParams) => {
  return await api
    .post(`${endpoint}/${id}/disarm/${partition}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const sendBypassZones = async ({
  id,
  data,
  endpoint,
}: IBypassZoneParams) => {
  return await api
    .post(`${endpoint}/${id}/bypassZone`, { zones: data })
    .then((response: any) => response.data)
    .catch((error: any) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const sendSingleBypassZone = async ({
  id,
  zone,
  endpoint,
}: ISingleBypassZoneParams) => {
  return await api
    .post(`${endpoint}/${id}/bypassZone/${zone}`)
    .then((response: any) => response.data)
    .catch((error: any) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const sendPgmActivation = async ({
  id,
  pgm,
  endpoint,
}: IPgmActivationParams) => {
  return await api
    .post(`${endpoint}/${id}/pgm/activation/${pgm}`)
    .then((response: any) => response.data)
    .catch((error: any) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const sendPgmDeactivation = async ({
  id,
  pgm,
  endpoint,
}: IPgmActivationParams) => {
  return await api
    .post(`${endpoint}/${id}/pgm/deactivation/${pgm}`)
    .then((response: any) => response.data)
    .catch((error: any) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
